import AppState from "../services/AppState";

export function createState() {
  // note the use of this which refers to observable instance of the store
  return new AppState();
}

export type TState = ReturnType<typeof createState>;
